import { SyncModal } from "./SyncModal";

export default SyncModal;
